import React, { useEffect, useState } from "react"
import Block from "@bappweb/block"
import "../assetsv2/style.scss"
import Button from "@bappweb/button"
import { useAppDispatch } from "../../../config/hook"
import { setSessionData } from "src/projects/pos-basvuru/state/sessionData"

const StickyHeader = ({ campaigns }) => {
  const dispatch = useAppDispatch()

  const handleFocusInput = () => {
    document.getElementById('identityNumber')?.focus();
    dispatch(
      setSessionData({
        isFocusInput: true
      })
    )
  }

  return (
    <Block type="header" className="landing-header-container landing-header-container-red">
      <Block className="sticky fixed">
        <Block className="container sticky-container">
          <Block className="sticky-content">
            <Block className="sticky-text" dangerouslySetInnerHTML={{ __html: campaigns }} >
            </Block>
            <Button
              text="Hemen Başvur" type="submit" className="btn-white sticky-button" disabled={false} secondary={true}
              onClick={handleFocusInput} />
          </Block>
        </Block>
      </Block>
    </Block>
  )
}

export default StickyHeader
